import React from 'react'
import _ from 'lodash'
import { Accordion } from 'react-bootstrap'


import AddDailyLimitModal from './../../../add_daily_limit'
import UpdateDailyLimitModal from './../../../update_daily_limit'
import RemoveDailyLimit from './../../../remove_daily_limit'
import AllowedDailyLimitModal from './../../../allowed_daily_limit'
import UpdateRateLimitModal from './../../../update_api_rate_limit'
import RemoveRateLimitModel from './../../../remove_api_rate_limit'
import UpdateDeepVerifyListSizeModal from './../../../update_deep_verify_list_size'

export const totalRemainingCreditsFormatter = ({ value }) => {
  return (
    <>
      {
        value !== null
          ? value.toLocaleString()
          : 'Unlimited'
      }
    </>
  )
}

export const payAsYouGoCreditsFormatter = ({ value }) => {
  return (
    <>
      {value ? value.toLocaleString() : '-'}
    </>
  )
}

export const subscriptionCreditsFormatter = ({ value }) => {
  return (
    <>
      {value ? value.toLocaleString() : '-'}
    </>
  )
}

export const recurCreditsFormatter = ({ value }) => {
  return (
    <>
      {value ? value.toLocaleString() : '-'}
    </>
  )
}


export const apiRateLimitFormatter = ({ userData, getUserInfo, client, label }) => {
  if (userData.user_type !== 'individual')
    return null

  return (
    <>
      <span>{label}</span>
      <div>
        <div className='d-flex'>
          <div className='mx-2'>
            <UpdateRateLimitModal
              data={userData}
              getUserInfo={getUserInfo}
              client={client}
            />
          </div>
          <div>
            <RemoveRateLimitModel
              data={userData}
              getUserInfo={getUserInfo}
              client={client}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export const instantEmailVerifyFormatter = ({ value, label, userData, additionalUserData }) => {

  if (!value)
    value = '-'
  else
    value = value.toLocaleString('en-US')

  // let planRPM = 0
  let addonRPM = 0
  let crmRPM = 0
  let mplRPM = 0
  if (!_.isEmpty(additionalUserData)) {
    // subscription details
    let subscriptionDetails = additionalUserData.subscription_details

    // credit plan subs
    // let planSubs = _.find(subscriptionDetails, { product_type: 'plan' })
    // let planAddons = planSubs.addons
    // planRPM = _.find(planAddons, { action: 'email-verification-api-rate-limit' }).count.toLocaleString('en-US')

    // addon subs
    let addonSubs = _.find(subscriptionDetails, sd => _.includes(sd.name, 'email-verification-api-rate-limit'))
    if (!_.isEmpty(addonSubs)) {
      addonRPM = addonSubs.limits.toLocaleString('en-US')
    }

    // permanent limits
    let permanentLimits = additionalUserData.permanent_limits
    if (!_.isEmpty(permanentLimits)) {
      let permaLimits = _.find(permanentLimits, pl => _.includes(pl.last_product_name, 'email-verification-api-rate-limit'))
      if (!_.isEmpty(permaLimits)) {
        crmRPM = permaLimits.limits.toLocaleString('en-US')
      }
    }

    // max purchased limits
    let maxPurchasedLimits = additionalUserData.max_purchased_limit
    if (!_.isEmpty(maxPurchasedLimits)) {
      let maxPermaLimits = _.find(maxPurchasedLimits, mpl => _.includes(mpl.name, 'email-verification-api-rate-limit'))
      if (!_.isEmpty(maxPermaLimits)) {
        mplRPM = maxPermaLimits.limit.total.toLocaleString('en-US')
      }
    }
  }

  if (userData.user_role !== 'owner') {
    return (
      <span className='d-flex justify-content-between w-100 pe-3'>
        <span>{label}</span>
        <span>{value}</span>
      </span>
    )
  }

  return (
    <Accordion
      className='limit-breakup-accordion'
      flush
    >
      <Accordion.Item eventKey={0}>
        <Accordion.Header>
          <span className='d-flex justify-content-between w-100 pe-3'>
            <span>{label}</span>
            <span>{value}</span>
          </span>
        </Accordion.Header>
        <Accordion.Body>
          <div className='d-flex flex-column gap-1'>
            {/* <span className='d-flex justify-content-between w-100 pe-2'>
              <span>{'Plan Subscription'}</span>
              <span>{planRPM}</span>
            </span> */}
            <span className='d-flex justify-content-between w-100 pe-2'>
              <span>{'Addon Subscription'}</span>
              <span>{addonRPM}</span>
            </span>
            <span className='d-flex justify-content-between w-100 pe-2'>
              <span>{'CRM'}</span>
              <span>{crmRPM}</span>
            </span>
            <span className='d-flex justify-content-between w-100 pe-2'>
              <span>{'Max Purchased Limits'}</span>
              <span>{mplRPM}</span>
            </span>
          </div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  )
}

export const parallelBulkEmailVerifyFormatter = ({ value, label, userData, additionalUserData }) => {

  if (!value)
    value = '-'
  else
    value = value.toLocaleString('en-US')

  // let planRPM = 0
  let addonRPM = 0
  let crmRPM = 0
  let mplRPM = 0
  if (!_.isEmpty(additionalUserData)) {
    // subscription details
    let subscriptionDetails = additionalUserData.subscription_details

    // credit plan subs
    // let planSubs = _.find(subscriptionDetails, { product_type: 'plan' })
    // let planAddons = planSubs.addons
    // planRPM = _.find(planAddons, { action: 'parallel-bulk-email-verification-limit' }).count.toLocaleString('en-US')

    // addon subs
    let addonSubs = _.find(subscriptionDetails, sd => _.includes(sd.name, 'parallel-bulk-email-verification-limit'))
    if (!_.isEmpty(addonSubs)) {
      addonRPM = addonSubs.limits.toLocaleString('en-US')
    }

    // permanent limits
    let permanentLimits = additionalUserData.permanent_limits
    if (!_.isEmpty(permanentLimits)) {
      let permaLimits = _.find(permanentLimits, pl => _.includes(pl.last_product_name, 'parallel-bulk-email-verification-limit'))
      if (!_.isEmpty(permaLimits)) {
        crmRPM = permaLimits.limits.toLocaleString('en-US')
      }
    }

    // max purchased limits
    let maxPurchasedLimits = additionalUserData.max_purchased_limit
    if (!_.isEmpty(maxPurchasedLimits)) {
      let maxPermaLimits = _.find(maxPurchasedLimits, mpl => _.includes(mpl.name, 'parallel-bulk-email-verification-limit'))
      if (!_.isEmpty(maxPermaLimits)) {
        mplRPM = maxPermaLimits.limit.total.toLocaleString('en-US')
      }
    }
  }

  if (userData.user_role !== 'owner') {
    return (
      <span className='d-flex justify-content-between w-100 pe-3'>
        <span>{label}</span>
        <span>{value}</span>
      </span>
    )
  }

  return (
    <Accordion
      className='limit-breakup-accordion'
      flush
    >
      <Accordion.Item eventKey={0}>
        <Accordion.Header>
          <span className='d-flex justify-content-between w-100 pe-3'>
            <span>{label}</span>
            <span>{value}</span>
          </span>
        </Accordion.Header>
        <Accordion.Body>
          <div className='d-flex flex-column gap-1'>
            {/* <span className='d-flex justify-content-between w-100 pe-2'>
              <span>{'Plan Subscription'}</span>
              <span>{planRPM}</span>
            </span> */}
            <span className='d-flex justify-content-between w-100 pe-2'>
              <span>{'Addon Subscription'}</span>
              <span>{addonRPM}</span>
            </span>
            <span className='d-flex justify-content-between w-100 pe-2'>
              <span>{'CRM'}</span>
              <span>{crmRPM}</span>
            </span>
            <span className='d-flex justify-content-between w-100 pe-2'>
              <span>{'Max Purchased Limits'}</span>
              <span>{mplRPM}</span>
            </span>
          </div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  )
}

export const instantEmailFinderFormatter = ({ value, label, userData, additionalUserData }) => {

  if (!value)
    value = '-'
  else
    value = value.toLocaleString('en-US')

  // let planRPM = 0
  let addonRPM = 0
  let crmRPM = 0
  let mplRPM = 0
  if (!_.isEmpty(additionalUserData)) {
    // subscription details
    let subscriptionDetails = additionalUserData.subscription_details

    // credit plan subs
    // let planSubs = _.find(subscriptionDetails, { product_type: 'plan' })
    // let planAddons = planSubs.addons
    // planRPM = _.find(planAddons, { action: 'email-finder-api-rate-limit' }).count.toLocaleString('en-US')

    // addon subs
    let addonSubs = _.find(subscriptionDetails, sd => _.includes(sd.name, 'email-finder-api-rate-limit'))
    if (!_.isEmpty(addonSubs)) {
      addonRPM = addonSubs.limits.toLocaleString('en-US')
    }

    // permanent limits
    let permanentLimits = additionalUserData.permanent_limits
    if (!_.isEmpty(permanentLimits)) {
      let permaLimits = _.find(permanentLimits, pl => _.includes(pl.last_product_name, 'email-finder-api-rate-limit'))
      if (!_.isEmpty(permaLimits)) {
        crmRPM = permaLimits.limits.toLocaleString('en-US')
      }
    }

    // max purchased limits
    let maxPurchasedLimits = additionalUserData.max_purchased_limit
    if (!_.isEmpty(maxPurchasedLimits)) {
      let maxPermaLimits = _.find(maxPurchasedLimits, mpl => _.includes(mpl.name, 'email-finder-api-rate-limit'))
      if (!_.isEmpty(maxPermaLimits)) {
        mplRPM = maxPermaLimits.limit.total.toLocaleString('en-US')
      }
    }
  }

  if (userData.user_role !== 'owner') {
    return (
      <span className='d-flex justify-content-between w-100 pe-3'>
        <span>{label}</span>
        <span>{value}</span>
      </span>
    )
  }

  return (
    <Accordion
      className='limit-breakup-accordion'
      flush
    >
      <Accordion.Item eventKey={0}>
        <Accordion.Header>
          <span className='d-flex justify-content-between w-100 pe-3'>
            <span>{label}</span>
            <span>{value}</span>
          </span>
        </Accordion.Header>
        <Accordion.Body>
          <div className='d-flex flex-column gap-1'>
            {/* <span className='d-flex justify-content-between w-100 pe-2'>
              <span>{'Plan Subscription'}</span>
              <span>{planRPM}</span>
            </span> */}
            <span className='d-flex justify-content-between w-100 pe-2'>
              <span>{'Addon Subscription'}</span>
              <span>{addonRPM}</span>
            </span>
            <span className='d-flex justify-content-between w-100 pe-2'>
              <span>{'CRM'}</span>
              <span>{crmRPM}</span>
            </span>
            <span className='d-flex justify-content-between w-100 pe-2'>
              <span>{'Max Purchased Limits'}</span>
              <span>{mplRPM}</span>
            </span>
          </div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  )
}

export const parallelBulkEmailFinderFormatter = ({ value, label, userData, additionalUserData }) => {

  if (!value)
    value = '-'
  else
    value = value.toLocaleString('en-US')

  // let planRPM = 0
  let addonRPM = 0
  let crmRPM = 0
  let mplRPM = 0
  if (!_.isEmpty(additionalUserData)) {
    // subscription details
    let subscriptionDetails = additionalUserData.subscription_details

    // credit plan subs
    // let planSubs = _.find(subscriptionDetails, { product_type: 'plan' })
    // let planAddons = planSubs.addons
    // planRPM = _.find(planAddons, { action: 'parallel-bulk-email-finder-limit' }).count.toLocaleString('en-US')

    // addon subs
    let addonSubs = _.find(subscriptionDetails, sd => _.includes(sd.name, 'parallel-bulk-email-finder-limit'))
    if (!_.isEmpty(addonSubs)) {
      addonRPM = addonSubs.limits.toLocaleString('en-US')
    }

    // permanent limits
    let permanentLimits = additionalUserData.permanent_limits
    if (!_.isEmpty(permanentLimits)) {
      let permaLimits = _.find(permanentLimits, pl => _.includes(pl.last_product_name, 'parallel-bulk-email-finder-limit'))
      if (!_.isEmpty(permaLimits)) {
        crmRPM = permaLimits.limits.toLocaleString('en-US')
      }
    }

    // max purchased limits
    let maxPurchasedLimits = additionalUserData.max_purchased_limit
    if (!_.isEmpty(maxPurchasedLimits)) {
      let maxPermaLimits = _.find(maxPurchasedLimits, mpl => _.includes(mpl.name, 'parallel-bulk-email-finder-limit'))
      if (!_.isEmpty(maxPermaLimits)) {
        mplRPM = maxPermaLimits.limit.total.toLocaleString('en-US')
      }
    }
  }

  if (userData.user_role !== 'owner') {
    return (
      <span className='d-flex justify-content-between w-100 pe-3'>
        <span>{label}</span>
        <span>{value}</span>
      </span>
    )
  }

  return (
    <Accordion
      className='limit-breakup-accordion'
      flush
    >
      <Accordion.Item eventKey={0}>
        <Accordion.Header>
          <span className='d-flex justify-content-between w-100 pe-3'>
            <span>{label}</span>
            <span>{value}</span>
          </span>
        </Accordion.Header>
        <Accordion.Body>
          <div className='d-flex flex-column gap-1'>
            {/* <span className='d-flex justify-content-between w-100 pe-2'>
              <span>{'Plan Subscription'}</span>
              <span>{planRPM}</span>
            </span> */}
            <span className='d-flex justify-content-between w-100 pe-2'>
              <span>{'Addon Subscription'}</span>
              <span>{addonRPM}</span>
            </span>
            <span className='d-flex justify-content-between w-100 pe-2'>
              <span>{'CRM'}</span>
              <span>{crmRPM}</span>
            </span>
            <span className='d-flex justify-content-between w-100 pe-2'>
              <span>{'Max Purchased Limits'}</span>
              <span>{mplRPM}</span>
            </span>
          </div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  )
}

export const parallelBulkProspectEnrichFormatter = ({ value, label, userData, additionalUserData }) => {

  if (!value)
    value = '-'
  else
    value = value.toLocaleString('en-US')

  // let planRPM = 0
  let addonRPM = 0
  let crmRPM = 0
  let mplRPM = 0
  if (!_.isEmpty(additionalUserData)) {
    // subscription details
    let subscriptionDetails = additionalUserData.subscription_details

    // credit plan subs
    // let planSubs = _.find(subscriptionDetails, { product_type: 'plan' })
    // let planAddons = planSubs.addons
    // planRPM = _.find(planAddons, { action: 'parallel-bulk-prospect-enrich-limit' }).count.toLocaleString('en-US')

    // addon subs
    let addonSubs = _.find(subscriptionDetails, sd => _.includes(sd.name, 'parallel-bulk-prospect-enrich-limit'))
    if (!_.isEmpty(addonSubs)) {
      addonRPM = addonSubs.limits.toLocaleString('en-US')
    }

    // permanent limits
    let permanentLimits = additionalUserData.permanent_limits
    if (!_.isEmpty(permanentLimits)) {
      let permaLimits = _.find(permanentLimits, pl => _.includes(pl.last_product_name, 'parallel-bulk-prospect-enrich-limit'))
      if (!_.isEmpty(permaLimits)) {
        crmRPM = permaLimits.limits.toLocaleString('en-US')
      }
    }

    // max purchased limits
    let maxPurchasedLimits = additionalUserData.max_purchased_limit
    if (!_.isEmpty(maxPurchasedLimits)) {
      let maxPermaLimits = _.find(maxPurchasedLimits, mpl => _.includes(mpl.name, 'parallel-bulk-prospect-enrich-limit'))
      if (!_.isEmpty(maxPermaLimits)) {
        mplRPM = maxPermaLimits.limit.total.toLocaleString('en-US')
      }
    }
  }

  if (userData.user_role !== 'owner') {
    return (
      <span className='d-flex justify-content-between w-100 pe-3'>
        <span>{label}</span>
        <span>{value}</span>
      </span>
    )
  }

  return (
    <Accordion
      className='limit-breakup-accordion'
      flush
    >
      <Accordion.Item eventKey={0}>
        <Accordion.Header>
          <span className='d-flex justify-content-between w-100 pe-3'>
            <span>{label}</span>
            <span>{value}</span>
          </span>
        </Accordion.Header>
        <Accordion.Body>
          <div className='d-flex flex-column gap-1'>
            {/* <span className='d-flex justify-content-between w-100 pe-2'>
              <span>{'Plan Subscription'}</span>
              <span>{planRPM}</span>
            </span> */}
            <span className='d-flex justify-content-between w-100 pe-2'>
              <span>{'Addon Subscription'}</span>
              <span>{addonRPM}</span>
            </span>
            <span className='d-flex justify-content-between w-100 pe-2'>
              <span>{'CRM'}</span>
              <span>{crmRPM}</span>
            </span>
            <span className='d-flex justify-content-between w-100 pe-2'>
              <span>{'Max Purchased Limits'}</span>
              <span>{mplRPM}</span>
            </span>
          </div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  )
}

export const deepVerifyListSizeFormatter = ({
  value,
  label,
  userData,
  getUserInfo,
  client 
}) => {
  if (!value)
    value = '-'
  else
    value = value.toLocaleString('en-US')

  return (
    <>
      <span>{label}</span>
      <div>
        <div className='d-flex'>
          <span>{value}</span>
          <div className='mx-2'>
            <UpdateDeepVerifyListSizeModal
              data={userData}
              getUserInfo={getUserInfo}
              client={client}
            />   
          </div>
        </div>
      </div>
    </>
  )
}

export const dailyLimitFormatter = ({ userData, getUserInfo, client, label }) => {
  if (userData.user_type !== 'individual')
    return null

  return (
    <>
      <span>{label}</span>
      <div>
        {
          !userData.limits.allowed_daily_limit
            ? (
              <AddDailyLimitModal
                data={userData}
                getUserInfo={getUserInfo}
                client={client}
              />
            )
            : null
        }
        {
          userData.limits.allowed_daily_limit
            ? (
              <RemoveDailyLimit
                data={userData}
                getUserInfo={getUserInfo}
                client={client}
              />
            )
            : null
        }
      </div>
    </>
  )

}

export const remainingDailyLimitFormatter = ({ userData, getUserInfo, client, label }) => {
  if (!userData.limits.allowed_daily_limit)
    return null

  return (
    <>
      <span>{label}</span>
      <div className='d-flex'>
        <p className='m-0'>{(userData.credits.available_daily_limit ?? 'Unlimited').toLocaleString()}</p>
        {userData.user_type === 'individual' && userData.limits.allowed_daily_limit ? (
          <div className='mx-2'>
            <UpdateDailyLimitModal
              data={userData}
              getUserInfo={getUserInfo}
              client={client}
            />
          </div>
        ) : null}
      </div>
    </>
  )
}

export const allowedDailyLimitFormatter = ({ userData, getUserInfo, client, label }) => {
  if (!userData.limits.allowed_daily_limit)
    return null

  return (
    <>
      <span>{label}</span>
      <div className='d-flex'>
        <p className='m-0'>{(userData.limits.allowed_daily_limit ?? 'Unlimited').toLocaleString()}</p>
        {userData.user_type === 'individual' ? (
          <div className='mx-2'>
            <AllowedDailyLimitModal
              data={userData}
              getUserInfo={getUserInfo}
              client={client}
            />
          </div>
        ) : null}
      </div>
    </>
  )
}

export const acrStatusFormatter = ({ value }) => {
  return value
}

export const acrThresholdFormatter = ({ value }) => {
  return value?.toLocaleString('en-US')
}

export const acrQuantityFormatter = ({ value }) => {
  return value?.toLocaleString('en-US')
}

export const acrPriceFormatter = ({ value }) => {
  return value?.toLocaleString('en-US')
}

export const acrCurrencyFormatter = ({ value }) => {
  return value
}

export const acrCouponFormatter = ({ value }) => {
  return value
}

// cop
export const instantPhoneNumberValidatorFormatter = ({ value, label }) => {
  return (
    <>
      <p>{label}</p>
      <div>
        {value ? value.toLocaleString() : '-'}
      </div>
    </>
  )
}

export const copDailyLimitFormatter = ({ userData, getUserInfo, client, label }) => {
  return (
    <>
      <p>{label}</p>
      <div>
        {userData.user_type === 'individual' ? (
          userData &&
            !userData.limits.allowed_daily_verify_limit
            ? (
              <AddDailyLimitModal
                data={userData}
                getUserInfo={getUserInfo}
                client={client}
              />
            ) : null
        ) : null}
        {userData.limits.allowed_daily_verify_limit && userData.user_type === 'individual' ? (
          <RemoveDailyLimit
            data={userData}
            getUserInfo={getUserInfo}
            client={client}
          />
        ) : null}
      </div>
    </>
  )
}

export const copRemainingDailyLimitFormatter = ({ userData, getUserInfo, client, label }) => {
  return (
    <>
      {userData.limits.allowed_daily_verify_limit ? (
        <p>{label}</p>
      ) : null}
      <div>
        {userData.limits.allowed_daily_verify_limit ? (
          <div className='d-flex'>
            <p>{(userData.credits.available_daily_verify_limit ?? 'Unlimited').toLocaleString()}</p>
            {userData.user_type === 'individual' ? (
              <div className='mx-2'>
                <UpdateDailyLimitModal
                  data={userData}
                  getUserInfo={getUserInfo}
                  client={client}
                />
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    </>
  )
}

export const copAllowedDailyLimitFormatter = ({ userData, getUserInfo, client, label }) => {
  return (
    <>
      {userData.limits.allowed_daily_verify_limit ? (
        <p>{label}</p>
      ) : null}
      <div>
        {userData.limits.allowed_daily_verify_limit ? (
          <div className='d-flex'>
            <p>{(userData.limits.allowed_daily_verify_limit ?? 'Unlimited').toLocaleString()}</p>
            {userData.user_type === 'individual' ? (
              <div className='mx-2'>
                <AllowedDailyLimitModal
                  data={userData}
                  getUserInfo={getUserInfo}
                  client={client}
                />
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    </>
  )
}